
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as mePLsNr1WWUTXQnTLAm6mK93jzW2uE2drR2d3FfpSNtDYMeta } from "/var/www/laporanJP/pages/hr/me.vue?macro=true";
import { default as IconsX6l8TsIKX5OpOg5KI1ULYiWv3Hry6YQJzxxUFSmUwLgMeta } from "/var/www/laporanJP/pages/Icons.vue?macro=true";
import { default as indexvcAxQquUt_45aI25rHt1lxl0fTbrUimsI1hYS8jjHIpDsMeta } from "/var/www/laporanJP/pages/index.vue?macro=true";
import { default as sspcazerFL_9Pr_l6pj8a3Cux5KWySKVpU9_LwjOhwvWgwMeta } from "/var/www/laporanJP/pages/tax/ssp.vue?macro=true";
import { default as vathY9yB2zUnSM7m9FyKZGDi3wXhugp0f5Zr2G01c_458tucMeta } from "/var/www/laporanJP/pages/tax/vat.vue?macro=true";
import { default as cash_45bankMgef0pYxUhmvy5IwUgHhvlBd_fpgAdUmvQH3677cymMMeta } from "/var/www/laporanJP/pages/cash-bank.vue?macro=true";
import { default as indexc5Lg_l8hhFR2DKsmNzb03wSEwhp1hhcFZ3V_Wkg9JnAMeta } from "/var/www/laporanJP/pages/tax/index.vue?macro=true";
import { default as pph211WCCMIreUWwD0Nyxufp4Yxjv6WJ3ivkMdbCo4jZNTFMMeta } from "/var/www/laporanJP/pages/tax/pph21.vue?macro=true";
import { default as ShadownONvhkeFuM7cTnQlWvWzj6Q1shcTE_y_qoRMvSi5QPQMeta } from "/var/www/laporanJP/pages/ui/Shadow.vue?macro=true";
import { default as LoginKWBiSGYHV8TjJU9NJdFceSZPjnCRp_45prlgG7o2mmM8wMeta } from "/var/www/laporanJP/pages/auth/Login.vue?macro=true";
import { default as indexuzt_nRDiQ8xZK4idVvPNjvfnQXploWpzzwOQzf9JvUMMeta } from "/var/www/laporanJP/pages/kurs/index.vue?macro=true";
import { default as lkagYWFbnSx32iI5umZKxs_45g3nNfY8hT6o8vJ2NA9N1fwMeta } from "/var/www/laporanJP/pages/reports/lk.vue?macro=true";
import { default as fiscalaiF55Ykr_pkX_rMrq_87p8A14PP5NBP1GHLLYyJSyiwMeta } from "/var/www/laporanJP/pages/tax/fiscal.vue?macro=true";
import { default as indexbUa8Z9W0RyQvX5LUPVpZBqV4PyjuljWpvFJh_45q1uraUMeta } from "/var/www/laporanJP/pages/audit/index.vue?macro=true";
import { default as payslips1_aYnhlYKjjUoLdKdoLO8CYsDDUdKv0JXwJTDi4N2R4Meta } from "/var/www/laporanJP/pages/hr/payslips.vue?macro=true";
import { default as Sample_45PageJcHi_45m5_ylZryqse7BwFO6as4mM0q5Rf6qMTXQV0vywMeta } from "/var/www/laporanJP/pages/Sample-Page.vue?macro=true";
import { default as indexm_WBAaS4n37MjPeAh33K6IL32MEt_45swVjwuiclkvHSoMeta } from "/var/www/laporanJP/pages/tasya/index.vue?macro=true";
import { default as indexHZ8ImUgdV9vpGLGV6ERecFwCw8GYPS02lDCFmMg9TDoMeta } from "/var/www/laporanJP/pages/users/index.vue?macro=true";
import { default as indexupDYH3fCJDutvaTNOwCO9J9vAHcNTG_45byZXO4yyeo04Meta } from "/var/www/laporanJP/pages/backup/index.vue?macro=true";
import { default as employeesSdpypkpqqOb5Kom_45uXWhIIf1TLqgB7Ugsd8tbZH7ZrcMeta } from "/var/www/laporanJP/pages/hr/employees.vue?macro=true";
import { default as indexirnmTSNQb9ikZwKmeIguAZxm21c6qNBHspdJ7eGYNX0Meta } from "/var/www/laporanJP/pages/import/index.vue?macro=true";
import { default as indexVNs_45CKRDTQpro0vECS_0U5_45959aoRulekeoYGavelVwMeta } from "/var/www/laporanJP/pages/kasbon/index.vue?macro=true";
import { default as indexYj8u0jqqXCAIMgauMjwvMmBV5ZzSXTnZh6jVupHCfCYMeta } from "/var/www/laporanJP/pages/portal/index.vue?macro=true";
import { default as bankjpgxzPNB6A_45SHP8eU2uzw0VNwlW_45LedGHSIHDM2ymFMMeta } from "/var/www/laporanJP/pages/reports/bank.vue?macro=true";
import { default as cogsFQSNxoppVewhmEbBIFaILzQtV5u_RaUVxKSgidF6I4kMeta } from "/var/www/laporanJP/pages/reports/cogs.vue?macro=true";
import { default as calendarWM9Eo4wj_ZMAhU_XzIH4Hgf34MAKS0j56slVWKGGewUMeta } from "/var/www/laporanJP/pages/tax/calendar.vue?macro=true";
import { default as spt_45masaE2iNcFSA0fWQiQXsLv1s4rq1v5AzVRFyj79_kICyW_gMeta } from "/var/www/laporanJP/pages/tax/spt-masa.vue?macro=true";
import { default as index4gw8vTduEnfEV_D9ug9AHb_45M6jRe5yLui3dGoh5vhvEMeta } from "/var/www/laporanJP/pages/account/index.vue?macro=true";
import { default as Registerv5_45Bw8OG6ic0LMc6ifnslOV8h3sxkKUu4ybKPELrNzkMeta } from "/var/www/laporanJP/pages/auth/Register.vue?macro=true";
import { default as index1ym1ycPQ354wHdqp7__45_BFl0VjxLpiCcoP1cpYqiKKcMeta } from "/var/www/laporanJP/pages/clients/index.vue?macro=true";
import { default as attendanceh60VnrihRTtFZ1dleYtDVtls4_0tTAFppQIWY1dwesgMeta } from "/var/www/laporanJP/pages/hr/attendance.vue?macro=true";
import { default as quick_45journalkk_Ek5vQIi9luxSdMpieCaRiIAKoefhjeNAblF6Dp2IMeta } from "/var/www/laporanJP/pages/quick-journal.vue?macro=true";
import { default as indexW_9PRUTsJLTMJiFoV2MbbQNcfFQeGIlBwjr6ZiA3lWsMeta } from "/var/www/laporanJP/pages/reports/index.vue?macro=true";
import { default as omsetKVS31iGRID9WOpSYJUo5cc_s0cDmWURRwCyG3ad52uYMeta } from "/var/www/laporanJP/pages/reports/omset.vue?macro=true";
import { default as documentsr3RihrNY9A6DyQbi4LHKrN_eqZnVsb9qsuXS71Y77lEMeta } from "/var/www/laporanJP/pages/tax/documents.vue?macro=true";
import { default as TypographyOAguufAe0FR5_45bVcXyNmjil0jh7VE27Txskq6Y9am0cMeta } from "/var/www/laporanJP/pages/ui/Typography.vue?macro=true";
import { default as indexhv7oaWqhPnsuXXPkRKoga0n9_453DppegQRUx59qse1QkMeta } from "/var/www/laporanJP/pages/accounts/index.vue?macro=true";
import { default as indexgQSk_45ljf0G_45YOUJ8G2A6HO9vXJjcckuE7TCjPrl606UMeta } from "/var/www/laporanJP/pages/calendar/index.vue?macro=true";
import { default as indexdmHmx_45jWMS_45vJnuiJXz_oLvsOjaShsc5UuqAtKq8R7gMeta } from "/var/www/laporanJP/pages/invoices/index.vue?macro=true";
import { default as entry09wuZpLfovp_znf190ZUNAf4ffVKABp4Upwc7QjOxlUMeta } from "/var/www/laporanJP/pages/journals/entry.vue?macro=true";
import { default as indexCdnkWHQwfZUsGW2kWRPQOuyFPBjcx9ND7CNx8QW_e_45cMeta } from "/var/www/laporanJP/pages/journals/index.vue?macro=true";
import { default as indexJ9PfICxcl42T39oGVL5CwQELQwAE3qG8g_9InsnbPpIMeta } from "/var/www/laporanJP/pages/products/index.vue?macro=true";
import { default as assetsP7DWtEvs9GcNq_APEU1O4oNXc38JpnNH6JTCx7uz7vwMeta } from "/var/www/laporanJP/pages/reports/assets.vue?macro=true";
import { default as budgetogZQzes6E1tlP7cqVe_WoGGlY0R9gYoK71THCPaTGD4Meta } from "/var/www/laporanJP/pages/reports/budget.vue?macro=true";
import { default as equityUDjCYv_IfEAzB15d9vuyKCrPdyoMthylkG2Ws48VjCwMeta } from "/var/www/laporanJP/pages/reports/equity.vue?macro=true";
import { default as ledgerXw0WhkD4geMqHZQEsXoybyCabNgkXS2C668EKr8NLKUMeta } from "/var/www/laporanJP/pages/reports/ledger.vue?macro=true";
import { default as indexqw_Q_45Oia_sqyHogjMiOVzOSi6xgj1gVZk_45_W5u3XzrIMeta } from "/var/www/laporanJP/pages/whatsapp/index.vue?macro=true";
import { default as indexit0e8bCSUZmTYCua1szJJ6crYA6w7eBZK3MYi5SFos0Meta } from "/var/www/laporanJP/pages/companies/index.vue?macro=true";
import { default as qualityVMcJo4l1lpdy7zD0216HcL8IxkudwMf9PQLLXgfVq6QMeta } from "/var/www/laporanJP/pages/control/quality.vue?macro=true";
import { default as index5_pukJ4VnOc0Zx4OZ62BhTEAgzq_kRc40Tr0_45uLuR0QMeta } from "/var/www/laporanJP/pages/customers/index.vue?macro=true";
import { default as indexNlMJO9l_45RGjsrHeDbre_45nNOcsmfLZO5nFiKQ0MAkumwMeta } from "/var/www/laporanJP/pages/downloads/index.vue?macro=true";
import { default as lookupchjHGDFB3XR4_45t9UPjZW_wNMUgSo3b52tRDG6ga0pbwMeta } from "/var/www/laporanJP/pages/journals/lookup.vue?macro=true";
import { default as indexVlTzS3_qzdSwSLvXTEdRD4eXmCMXIXLqSD5OW_5KyiUMeta } from "/var/www/laporanJP/pages/marketing/index.vue?macro=true";
import { default as opening_45balanceTnKiYgGlFSOMvRa9PRgqP5XwD_45bpdzK_45kqIrLf_wj_4Meta } from "/var/www/laporanJP/pages/opening-balance.vue?macro=true";
import { default as indexyVyog4mo2RMmdLEPCVyQ9WtQdCpsKSfhoHeOiMr1u0sMeta } from "/var/www/laporanJP/pages/reminders/index.vue?macro=true";
import { default as accrualUeFxwiXQC42wS_hnc2xB_45qQ0qXwxsq_45SIdFQuedKvxIMeta } from "/var/www/laporanJP/pages/reports/accrual.vue?macro=true";
import { default as expenseEo07t8NeOMZ4njCmbwEdzE_45ElsH_45_VMfpTc27HiEKxcMeta } from "/var/www/laporanJP/pages/reports/expense.vue?macro=true";
import { default as revenuei8eQiXJels8ivYsYq0E8pXcVVipix0LqfwC8mh5L5woMeta } from "/var/www/laporanJP/pages/reports/revenue.vue?macro=true";
import { default as metLguVEfwZc1SbGxfv71xoSN4r_45ezvsZZ72_454foly70gMeta } from "/var/www/laporanJP/pages/tax/requests/me.vue?macro=true";
import { default as unearnedcjgXxndJLA9peR84g0mKILP9_05YfEO47NLKNX_Y8qAMeta } from "/var/www/laporanJP/pages/reports/unearned.vue?macro=true";
import { default as indexUFcjHRqhhlQq9AAqD5DHJWF_uajbb8hjQ5adpKgxXFQMeta } from "/var/www/laporanJP/pages/statements/index.vue?macro=true";
import { default as withholdingsLz56rJ93pWjEzihJYTOsgxyfkRdhZ3vdnDhf2lPrxY0Meta } from "/var/www/laporanJP/pages/tax/withholdings.vue?macro=true";
import { default as index1uMFB7FEnQ7W2JPBWnL4R73nFBffJIk1OJbWOmNoYYEMeta } from "/var/www/laporanJP/pages/engagements/index.vue?macro=true";
import { default as _91id_93EDsE0nwrV4CIeV5nRtDbyYvIq9T_45nt_459WTu20Mw9gFQMeta } from "/var/www/laporanJP/pages/hr/kasbon-qr/[id].vue?macro=true";
import { default as cash_45flowwquc1V0bm2qZBuEL377h7huD_1Hbe77U_wjQzlSUr0MMeta } from "/var/www/laporanJP/pages/reports/cash-flow.vue?macro=true";
import { default as inventory03CABbBbcSWR2TU0DNI8bi7ffhMvhK3cnHUXRUwbJ3cMeta } from "/var/www/laporanJP/pages/reports/inventory.vue?macro=true";
import { default as indexF_45L_451valVk2A8oF0w_456aGckgMUs5Jpd6gDMNfRDXQvMMeta } from "/var/www/laporanJP/pages/fixed-assets/index.vue?macro=true";
import { default as approvalseH4WcZ89j7y1hmUveC37jerrH1YJlYCxu_cjz1qDaQEMeta } from "/var/www/laporanJP/pages/journals/approvals.vue?macro=true";
import { default as indexZxcIxwXIl1qBw1nBq9RDX_SYpzojo8apGZRu3iBbNFEMeta } from "/var/www/laporanJP/pages/tax/requests/index.vue?macro=true";
import { default as indexiHcHztNBUzQYYTRr16JcKRHoIjb5gG9nmmSlYVZaCCQMeta } from "/var/www/laporanJP/pages/vendor-bills/index.vue?macro=true";
import { default as indexjfUx3Cx4wFaJq_UuP2KaCjib5uOExDEd_45ACDM4tsuX8Meta } from "/var/www/laporanJP/pages/bank-accounts/index.vue?macro=true";
import { default as dimensions1iS9uH4uXytWo2qCQA1GO7lwyeuhPrTWPgNoSYotRYAMeta } from "/var/www/laporanJP/pages/journals/dimensions.vue?macro=true";
import { default as pembetulanYbgnaHLRjfe3hkPSgYWGezjkCPo7lcDZfTv8MPF_45kDkMeta } from "/var/www/laporanJP/pages/journals/pembetulan.vue?macro=true";
import { default as comparativeZZOmggp2y4lwAAON9_qbVh_45yaBBBz7ivJJSYpVqqeZ4Meta } from "/var/www/laporanJP/pages/reports/comparative.vue?macro=true";
import { default as liabilitiestbWxY8jkwx7lOT0oyCE8haZ8tjHV_HrQg3_QjknWZUcMeta } from "/var/www/laporanJP/pages/reports/liabilities.vue?macro=true";
import { default as CardszFYQsLykHb_u0aR5XAlyRXUfITN7AhumZRW4v3m4LOsMeta } from "/var/www/laporanJP/pages/ui-components/Cards.vue?macro=true";
import { default as indexcmP004baagJZHR88jB5gpFHEQmRK9OpIdRV8H3p0vo0Meta } from "/var/www/laporanJP/pages/reconciliation/index.vue?macro=true";
import { default as consolidatedC_45ednlGXUqHgppkdYHkEabL2j5edgw9wbXYUhbQl7lIMeta } from "/var/www/laporanJP/pages/reports/consolidated.vue?macro=true";
import { default as depreciationMY_45LdGQuoNp2zMN3rpnlVZ_45j5qcAmkPbbS3Y_ptmnOwMeta } from "/var/www/laporanJP/pages/reports/depreciation.vue?macro=true";
import { default as intercompanycC9h80Bhel6r12OZHhAlMUbOQUmTdQyfnjZ6hILHK28Meta } from "/var/www/laporanJP/pages/reports/intercompany.vue?macro=true";
import { default as AlertsEZAGYjG70evPEkoFQ6IaNtGIc_45VVnfT92f1dOT8cntYMeta } from "/var/www/laporanJP/pages/ui-components/Alerts.vue?macro=true";
import { default as TablesCYTiCr7HkyVo_MEGYM4FZyV0QD0pFG6l6xDx9M7ScxsMeta } from "/var/www/laporanJP/pages/ui-components/Tables.vue?macro=true";
import { default as close_45wizardux4Zv3gCTPTX2Oi2eHss0_45i9_FI52ZCsEXpxVomPklUMeta } from "/var/www/laporanJP/pages/journals/close-wizard.vue?macro=true";
import { default as balance_45sheetQrquhkuJmjUXP8n9YnKdqaNEjvE7o7Xk9IqnZYEkew0Meta } from "/var/www/laporanJP/pages/reports/balance-sheet.vue?macro=true";
import { default as cash_45forecast2CNf4qL39lMCEamP9vEDCBeKvrFgONP4dxY3wJS2wLIMeta } from "/var/www/laporanJP/pages/reports/cash-forecast.vue?macro=true";
import { default as trial_45balancemU07WhwOroOTUTX5W_3fc1HKbDdIuw_rrxuxza0_eVYMeta } from "/var/www/laporanJP/pages/reports/trial-balance.vue?macro=true";
import { default as Buttonsm4id1rjmZj7uYCwKaiVItnBJE9PiPs4EpLI6LrhkMUwMeta } from "/var/www/laporanJP/pages/ui-components/Buttons.vue?macro=true";
import { default as close_45checklist5bPWO_45JoSBoXaC6tqIEAFYMHpklsFUk7i0_45kAlwdnE8Meta } from "/var/www/laporanJP/pages/control/close-checklist.vue?macro=true";
import { default as indexlRSVUYkLfcQoetDOF3V8Yl7fFIl9wYxdiFiz_45zKT6sYMeta } from "/var/www/laporanJP/pages/recurring-journals/index.vue?macro=true";
import { default as accounts_45payable_VGMihaWxs50b3W4B7doO58lcOtt5RNw_45zjD1kKWvmUMeta } from "/var/www/laporanJP/pages/reports/accounts-payable.vue?macro=true";
import { default as income_45statementSRm4l_CBGUpOh2kTrsDP4I8F7z1gabsgGj1IUH3roI8Meta } from "/var/www/laporanJP/pages/reports/income-statement.vue?macro=true";
import { default as accounts_45receivable3TQmkS_EN6LxTupYZgD8vAXcWkO53ZEu4Hy_45pdsWqzIMeta } from "/var/www/laporanJP/pages/reports/accounts-receivable.vue?macro=true";
import { default as component_45stubz6lYODmMDHWHCTffW8luJb_45ww8M2dn81HMVRKNypvvEMeta } from "/var/www/laporanJP/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubz6lYODmMDHWHCTffW8luJb_45ww8M2dn81HMVRKNypvvE } from "/var/www/laporanJP/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "hr-me",
    path: "/hr/me",
    component: () => import("/var/www/laporanJP/pages/hr/me.vue")
  },
  {
    name: "Icons",
    path: "/Icons",
    component: () => import("/var/www/laporanJP/pages/Icons.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/laporanJP/pages/index.vue")
  },
  {
    name: "tax-ssp",
    path: "/tax/ssp",
    component: () => import("/var/www/laporanJP/pages/tax/ssp.vue")
  },
  {
    name: "tax-vat",
    path: "/tax/vat",
    component: () => import("/var/www/laporanJP/pages/tax/vat.vue")
  },
  {
    name: "cash-bank",
    path: "/cash-bank",
    component: () => import("/var/www/laporanJP/pages/cash-bank.vue")
  },
  {
    name: "tax",
    path: "/tax",
    component: () => import("/var/www/laporanJP/pages/tax/index.vue")
  },
  {
    name: "tax-pph21",
    path: "/tax/pph21",
    component: () => import("/var/www/laporanJP/pages/tax/pph21.vue")
  },
  {
    name: "ui-Shadow",
    path: "/ui/Shadow",
    component: () => import("/var/www/laporanJP/pages/ui/Shadow.vue")
  },
  {
    name: "auth-Login",
    path: "/auth/Login",
    meta: LoginKWBiSGYHV8TjJU9NJdFceSZPjnCRp_45prlgG7o2mmM8wMeta || {},
    component: () => import("/var/www/laporanJP/pages/auth/Login.vue")
  },
  {
    name: "kurs",
    path: "/kurs",
    component: () => import("/var/www/laporanJP/pages/kurs/index.vue")
  },
  {
    name: "reports-lk",
    path: "/reports/lk",
    component: () => import("/var/www/laporanJP/pages/reports/lk.vue")
  },
  {
    name: "tax-fiscal",
    path: "/tax/fiscal",
    component: () => import("/var/www/laporanJP/pages/tax/fiscal.vue")
  },
  {
    name: "audit",
    path: "/audit",
    component: () => import("/var/www/laporanJP/pages/audit/index.vue")
  },
  {
    name: "hr-payslips",
    path: "/hr/payslips",
    component: () => import("/var/www/laporanJP/pages/hr/payslips.vue")
  },
  {
    name: "Sample-Page",
    path: "/Sample-Page",
    component: () => import("/var/www/laporanJP/pages/Sample-Page.vue")
  },
  {
    name: "tasya",
    path: "/tasya",
    component: () => import("/var/www/laporanJP/pages/tasya/index.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/var/www/laporanJP/pages/users/index.vue")
  },
  {
    name: "backup",
    path: "/backup",
    component: () => import("/var/www/laporanJP/pages/backup/index.vue")
  },
  {
    name: "hr-employees",
    path: "/hr/employees",
    component: () => import("/var/www/laporanJP/pages/hr/employees.vue")
  },
  {
    name: "import",
    path: "/import",
    component: () => import("/var/www/laporanJP/pages/import/index.vue")
  },
  {
    name: "kasbon",
    path: "/kasbon",
    component: () => import("/var/www/laporanJP/pages/kasbon/index.vue")
  },
  {
    name: "portal",
    path: "/portal",
    component: () => import("/var/www/laporanJP/pages/portal/index.vue")
  },
  {
    name: "reports-bank",
    path: "/reports/bank",
    component: () => import("/var/www/laporanJP/pages/reports/bank.vue")
  },
  {
    name: "reports-cogs",
    path: "/reports/cogs",
    component: () => import("/var/www/laporanJP/pages/reports/cogs.vue")
  },
  {
    name: "tax-calendar",
    path: "/tax/calendar",
    component: () => import("/var/www/laporanJP/pages/tax/calendar.vue")
  },
  {
    name: "tax-spt-masa",
    path: "/tax/spt-masa",
    component: () => import("/var/www/laporanJP/pages/tax/spt-masa.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/var/www/laporanJP/pages/account/index.vue")
  },
  {
    name: "auth-Register",
    path: "/auth/Register",
    meta: Registerv5_45Bw8OG6ic0LMc6ifnslOV8h3sxkKUu4ybKPELrNzkMeta || {},
    component: () => import("/var/www/laporanJP/pages/auth/Register.vue")
  },
  {
    name: "clients",
    path: "/clients",
    component: () => import("/var/www/laporanJP/pages/clients/index.vue")
  },
  {
    name: "hr-attendance",
    path: "/hr/attendance",
    component: () => import("/var/www/laporanJP/pages/hr/attendance.vue")
  },
  {
    name: "quick-journal",
    path: "/quick-journal",
    component: () => import("/var/www/laporanJP/pages/quick-journal.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/var/www/laporanJP/pages/reports/index.vue")
  },
  {
    name: "reports-omset",
    path: "/reports/omset",
    component: () => import("/var/www/laporanJP/pages/reports/omset.vue")
  },
  {
    name: "tax-documents",
    path: "/tax/documents",
    component: () => import("/var/www/laporanJP/pages/tax/documents.vue")
  },
  {
    name: "ui-Typography",
    path: "/ui/Typography",
    component: () => import("/var/www/laporanJP/pages/ui/Typography.vue")
  },
  {
    name: "accounts",
    path: "/accounts",
    component: () => import("/var/www/laporanJP/pages/accounts/index.vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    component: () => import("/var/www/laporanJP/pages/calendar/index.vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    component: () => import("/var/www/laporanJP/pages/invoices/index.vue")
  },
  {
    name: "journals-entry",
    path: "/journals/entry",
    component: () => import("/var/www/laporanJP/pages/journals/entry.vue")
  },
  {
    name: "journals",
    path: "/journals",
    component: () => import("/var/www/laporanJP/pages/journals/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/var/www/laporanJP/pages/products/index.vue")
  },
  {
    name: "reports-assets",
    path: "/reports/assets",
    component: () => import("/var/www/laporanJP/pages/reports/assets.vue")
  },
  {
    name: "reports-budget",
    path: "/reports/budget",
    component: () => import("/var/www/laporanJP/pages/reports/budget.vue")
  },
  {
    name: "reports-equity",
    path: "/reports/equity",
    component: () => import("/var/www/laporanJP/pages/reports/equity.vue")
  },
  {
    name: "reports-ledger",
    path: "/reports/ledger",
    component: () => import("/var/www/laporanJP/pages/reports/ledger.vue")
  },
  {
    name: "whatsapp",
    path: "/whatsapp",
    component: () => import("/var/www/laporanJP/pages/whatsapp/index.vue")
  },
  {
    name: "companies",
    path: "/companies",
    component: () => import("/var/www/laporanJP/pages/companies/index.vue")
  },
  {
    name: "control-quality",
    path: "/control/quality",
    component: () => import("/var/www/laporanJP/pages/control/quality.vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/var/www/laporanJP/pages/customers/index.vue")
  },
  {
    name: "downloads",
    path: "/downloads",
    component: () => import("/var/www/laporanJP/pages/downloads/index.vue")
  },
  {
    name: "journals-lookup",
    path: "/journals/lookup",
    component: () => import("/var/www/laporanJP/pages/journals/lookup.vue")
  },
  {
    name: "marketing",
    path: "/marketing",
    component: () => import("/var/www/laporanJP/pages/marketing/index.vue")
  },
  {
    name: "opening-balance",
    path: "/opening-balance",
    component: () => import("/var/www/laporanJP/pages/opening-balance.vue")
  },
  {
    name: "reminders",
    path: "/reminders",
    component: () => import("/var/www/laporanJP/pages/reminders/index.vue")
  },
  {
    name: "reports-accrual",
    path: "/reports/accrual",
    component: () => import("/var/www/laporanJP/pages/reports/accrual.vue")
  },
  {
    name: "reports-expense",
    path: "/reports/expense",
    component: () => import("/var/www/laporanJP/pages/reports/expense.vue")
  },
  {
    name: "reports-revenue",
    path: "/reports/revenue",
    component: () => import("/var/www/laporanJP/pages/reports/revenue.vue")
  },
  {
    name: "tax-requests-me",
    path: "/tax/requests/me",
    component: () => import("/var/www/laporanJP/pages/tax/requests/me.vue")
  },
  {
    name: "reports-unearned",
    path: "/reports/unearned",
    component: () => import("/var/www/laporanJP/pages/reports/unearned.vue")
  },
  {
    name: "statements",
    path: "/statements",
    component: () => import("/var/www/laporanJP/pages/statements/index.vue")
  },
  {
    name: "tax-withholdings",
    path: "/tax/withholdings",
    component: () => import("/var/www/laporanJP/pages/tax/withholdings.vue")
  },
  {
    name: "engagements",
    path: "/engagements",
    component: () => import("/var/www/laporanJP/pages/engagements/index.vue")
  },
  {
    name: "hr-kasbon-qr-id",
    path: "/hr/kasbon-qr/:id()",
    component: () => import("/var/www/laporanJP/pages/hr/kasbon-qr/[id].vue")
  },
  {
    name: "reports-cash-flow",
    path: "/reports/cash-flow",
    component: () => import("/var/www/laporanJP/pages/reports/cash-flow.vue")
  },
  {
    name: "reports-inventory",
    path: "/reports/inventory",
    component: () => import("/var/www/laporanJP/pages/reports/inventory.vue")
  },
  {
    name: "fixed-assets",
    path: "/fixed-assets",
    component: () => import("/var/www/laporanJP/pages/fixed-assets/index.vue")
  },
  {
    name: "journals-approvals",
    path: "/journals/approvals",
    component: () => import("/var/www/laporanJP/pages/journals/approvals.vue")
  },
  {
    name: "tax-requests",
    path: "/tax/requests",
    component: () => import("/var/www/laporanJP/pages/tax/requests/index.vue")
  },
  {
    name: "vendor-bills",
    path: "/vendor-bills",
    component: () => import("/var/www/laporanJP/pages/vendor-bills/index.vue")
  },
  {
    name: "bank-accounts",
    path: "/bank-accounts",
    component: () => import("/var/www/laporanJP/pages/bank-accounts/index.vue")
  },
  {
    name: "journals-dimensions",
    path: "/journals/dimensions",
    component: () => import("/var/www/laporanJP/pages/journals/dimensions.vue")
  },
  {
    name: "journals-pembetulan",
    path: "/journals/pembetulan",
    component: () => import("/var/www/laporanJP/pages/journals/pembetulan.vue")
  },
  {
    name: "reports-comparative",
    path: "/reports/comparative",
    component: () => import("/var/www/laporanJP/pages/reports/comparative.vue")
  },
  {
    name: "reports-liabilities",
    path: "/reports/liabilities",
    component: () => import("/var/www/laporanJP/pages/reports/liabilities.vue")
  },
  {
    name: "ui-components-Cards",
    path: "/ui-components/Cards",
    component: () => import("/var/www/laporanJP/pages/ui-components/Cards.vue")
  },
  {
    name: "reconciliation",
    path: "/reconciliation",
    component: () => import("/var/www/laporanJP/pages/reconciliation/index.vue")
  },
  {
    name: "reports-consolidated",
    path: "/reports/consolidated",
    component: () => import("/var/www/laporanJP/pages/reports/consolidated.vue")
  },
  {
    name: "reports-depreciation",
    path: "/reports/depreciation",
    component: () => import("/var/www/laporanJP/pages/reports/depreciation.vue")
  },
  {
    name: "reports-intercompany",
    path: "/reports/intercompany",
    component: () => import("/var/www/laporanJP/pages/reports/intercompany.vue")
  },
  {
    name: "ui-components-Alerts",
    path: "/ui-components/Alerts",
    component: () => import("/var/www/laporanJP/pages/ui-components/Alerts.vue")
  },
  {
    name: "ui-components-Tables",
    path: "/ui-components/Tables",
    component: () => import("/var/www/laporanJP/pages/ui-components/Tables.vue")
  },
  {
    name: "journals-close-wizard",
    path: "/journals/close-wizard",
    component: () => import("/var/www/laporanJP/pages/journals/close-wizard.vue")
  },
  {
    name: "reports-balance-sheet",
    path: "/reports/balance-sheet",
    component: () => import("/var/www/laporanJP/pages/reports/balance-sheet.vue")
  },
  {
    name: "reports-cash-forecast",
    path: "/reports/cash-forecast",
    component: () => import("/var/www/laporanJP/pages/reports/cash-forecast.vue")
  },
  {
    name: "reports-trial-balance",
    path: "/reports/trial-balance",
    component: () => import("/var/www/laporanJP/pages/reports/trial-balance.vue")
  },
  {
    name: "ui-components-Buttons",
    path: "/ui-components/Buttons",
    component: () => import("/var/www/laporanJP/pages/ui-components/Buttons.vue")
  },
  {
    name: "control-close-checklist",
    path: "/control/close-checklist",
    component: () => import("/var/www/laporanJP/pages/control/close-checklist.vue")
  },
  {
    name: "recurring-journals",
    path: "/recurring-journals",
    component: () => import("/var/www/laporanJP/pages/recurring-journals/index.vue")
  },
  {
    name: "reports-accounts-payable",
    path: "/reports/accounts-payable",
    component: () => import("/var/www/laporanJP/pages/reports/accounts-payable.vue")
  },
  {
    name: "reports-income-statement",
    path: "/reports/income-statement",
    component: () => import("/var/www/laporanJP/pages/reports/income-statement.vue")
  },
  {
    name: "reports-accounts-receivable",
    path: "/reports/accounts-receivable",
    component: () => import("/var/www/laporanJP/pages/reports/accounts-receivable.vue")
  },
  {
    name: component_45stubz6lYODmMDHWHCTffW8luJb_45ww8M2dn81HMVRKNypvvEMeta?.name,
    path: "/ui-components/:pathMatch(.*)",
    component: component_45stubz6lYODmMDHWHCTffW8luJb_45ww8M2dn81HMVRKNypvvE
  },
  {
    name: component_45stubz6lYODmMDHWHCTffW8luJb_45ww8M2dn81HMVRKNypvvEMeta?.name,
    path: "/ui/:pathMatch(.*)",
    component: component_45stubz6lYODmMDHWHCTffW8luJb_45ww8M2dn81HMVRKNypvvE
  }
]